// exept date and return foramted date
export function DateFormater(d) {
    const date = new Date(d)
    const [day, month, year] = [date.getDate(), date.getMonth() + 1, date.getFullYear()]
    return `${day}/${month}/${year}`
}